var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-row',[_c('v-col',[_c('v-data-table',{attrs:{"items":_vm.pendingImports,"headers":_vm.headers,"items-per-page":-1,"hide-default-footer":""}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }